module.exports = __webpack_public_path__ + "static/media/the-chef.b7c08c2f.png";